"use client";
import React from 'react';
import { Space } from '@sravni/react-design-system/lib/Space';
import { useIsMobile, useAnalytics } from '@sravni/react-utils';
import { useIntersectionObservers } from '../../../hooks/useIntersectionObservers.js';
import { AppBanner } from '../../AppBanner/ui/AppBanner.js';
import { ContactsBanner } from '../../ContactsBanner/ui/ContactsBanner.js';
import { StoresBanner } from '../../StoresBanner/ui/StoresBanner.js';
import modules_3f9ccc85 from '../styles/MainContent.module.less.js';

const MainContent = ({ variant, support, className, ...rest }) => {
    const isMobile = useIsMobile();
    const { pushEvent } = useAnalytics();
    const handleStoreInView = (inView, entry) => {
        if (inView && (entry.target instanceof HTMLElement || entry.target instanceof SVGSVGElement)) {
            const store = entry.target.dataset.store || '';
            pushEvent({
                event: 'mainEvent',
                eventCategory: 'Футер',
                eventAction: 'Показ ссылки в Store',
                eventLabel: `Футер|${store}`,
            });
        }
    };
    const { refs } = useIntersectionObservers({
        ids: ['qr', "GOOGLE_PLAY" /* STORES.GOOGLE_PLAY */, "APPLE_STORE" /* STORES.APPLE_STORE */, "HUAWEI_APP_GALLERY" /* STORES.HUAWEI_APP_GALLERY */, "RU_STORE" /* STORES.RU_STORE */],
        callback: handleStoreInView,
    });
    return (React.createElement(Space, { size: isMobile ? 16 : 32, direction: isMobile ? 'column' : 'row', className: className, wrap: true, ...rest },
        React.createElement(AppBanner, { ref: refs.qr, variant: variant, className: modules_3f9ccc85.appBanner }),
        React.createElement(StoresBanner, { refs: refs, variant: variant, className: modules_3f9ccc85.storesBanner }),
        support && React.createElement(ContactsBanner, { support: support, variant: variant, className: modules_3f9ccc85.contactsBanner })));
};
MainContent.displayName = 'MainContent';

export { MainContent };
//# sourceMappingURL=MainContent.js.map
